import React, { createContext, useContext, ReactNode } from "react";
import { TrainingModuleConfig } from "./moduleConfigs";

const TrainingModuleContext = createContext<TrainingModuleConfig | undefined>(
  undefined,
);

export const TrainingModuleProvider = ({
  config,
  children,
}: {
  config: TrainingModuleConfig;
  children: ReactNode;
}) => {
  return (
    <TrainingModuleContext.Provider value={config}>
      {children}
    </TrainingModuleContext.Provider>
  );
};

export const useTrainingModule = (): TrainingModuleConfig => {
  const context = useContext(TrainingModuleContext);
  if (!context) {
    throw new Error(
      "useTrainingModule must be used within a TrainingModuleProvider",
    );
  }
  return context;
};

export function withTrainingModule<P extends object>(
  Component: React.ComponentType<P>,
  config: TrainingModuleConfig,
): React.FC<P> {
  const Wrapped: React.FC<P> = (props) => (
    <TrainingModuleProvider config={config}>
      <Component {...props} />
    </TrainingModuleProvider>
  );
  Wrapped.displayName = `withTrainingModule(${
    Component.displayName || Component.name || "Component"
  })`;
  return Wrapped;
}
